export default __webpack_public_path__ + "static/media/Deepika Naharas.c4e0f268.jpg";